import React from 'react';
import ServiceCard from "./ServiceCard/ServiceCard";
import './Services.css';

const Services = props => {
    return (
        <div className="adg-container">
            <div className="adg-header">
                Services we Provide
            </div>
            <div className="services-container">
                <ServiceCard changeService={props.changeService} serviceKey="finAcc" icon="fas fa-2x fa-file-invoice-dollar" label="Finance & Accounting"/>
                <ServiceCard changeService={props.changeService} serviceKey="businessSuppServices" icon="fas fa-2x fa-briefcase" label="Business Support Services"/>
                <ServiceCard changeService={props.changeService} serviceKey="dueDiligence" icon="fas fa-2x fa-balance-scale" label="Due Diligence & Legal Advisory"/>
                <ServiceCard changeService={props.changeService} serviceKey="taxAdvisory" icon="fas fa-2x fa-money-bill-wave" label="Tax Advisory"/>
                <ServiceCard changeService={props.changeService} serviceKey="peopleManagememt" icon="fas fa-2x fa-users" label="People Management"/>
                <ServiceCard changeService={props.changeService} serviceKey="finAcc" icon="fab fa-2x fa-app-store-ios" label="Software Services"/>
            </div>

        </div>
    );
};

export default Services;


// WEBPACK FOOTER //
// ./src/Components/LandingPage/Services/Services.js